import ExtensionEventType from 'owa-service/lib/contract/ExtensionEventType';
import getExtensionEventByType from '../utils/getExtensionEventByType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getExtensibilityState, isExtensibilityContextInitialized } from 'owa-addins-store';

export function shouldForceFullCompose() {
    const context = getExtensibilityState().Context;
    const isInitialized = isExtensibilityContextInitialized();
    const policyEnabled = getUserConfiguration().SegmentationSettings.OnSendAddinsEnabled;

    if (context && isInitialized) {
        return policyEnabled && getExtensionEventByType(ExtensionEventType.ItemSend).length > 0;
    } else {
        // ExtensibilityContext failed to load or is still loading force anyway
        return policyEnabled;
    }
}
